._secondary-action-btn_1vsa4_1 {
  width: 44px; }
